export enum EPermissao {

    _ACESSO_GERAL = "9999",

    CGR_PRISMA = "0762",
    CGR_PRISMA_PREENCHER_LISTA_ARRANQUE = "0763",

    CGR_PRISMA_LISTA_ARRANQUE = "0764",
    CGR_PRISMA_LISTA_ARRANQUE_CONSULTAR = "0765",
    CGR_PRISMA_LISTA_ARRANQUE_REMOVER = "0766",
    CGR_PRISMA_LISTA_ARRANQUE_LOG = "0767",

    CGR_PRISMA_APONTAMENTO_RLI = "0768",
    CGR_PRISMA_APONTAMENTO_RLI_CONSULTAR = "0769",
    CGR_PRISMA_APONTAMENTO_RLI_REMOVER = "0770",

    CGR_PRISMA_DIARIO_BORDO = "0771",
    CGR_PRISMA_DIARIO_BORDO_CONSULTAR = "0772",
    
    CGR_PRISMA_EXTRATO_BANCARIO = "0775",
    CGR_PRISMA_IMPORTACAO_EXTRATO = "0776",
    CGR_PRISMA_CONSULTAR_EXTRATO = "0777",
    CGR_PRISMA_CONSULTAR_CONCILIACAO = "0778",
    CGR_PRISMA_CADASTRAR_CONCILIACAO = "0779",
    CGR_PRISMA_REMOVER_CONCILIACAO = "0780",
    CGR_PRISMA_CONSULTAR_CURVA_ABC = "0781",
    CGR_PRISMA_SOLICITACAO_GERAL = "0782",
    CGR_PRISMA_CONSULTAR_SOLICITACAO_GERAL = "0783",
    CGR_PRISMA_CADASTRAR_SOLICITACAO_GERAL = "0784",
    CGR_PRISMA_APROVACAO_SOLICITACAO_GERAL = "0785",
    CGR_PRISMA_PEDIDO_COMPRA = "0786",
    CGR_PRISMA_LISTAR_PEDIDO_COMPRA = "0787",
    CGR_PRISMA_CADASTRAR_PEDIDO_COMPRA = "0788",
    CGR_PRISMA_ALTERAR_PEDIDO_COMPRA = "0789",
    CGR_PRISMA_ALTERAR_PEDIDO_COMPRA_GERAL = "0790",
    CGR_PRISMA_ALTERAR_ITEM_MP_PEDIDO_COM_ENTREGA_PARCIAL = "0791",
    CGR_PRISMA_ALTERAR_STATUS_PEDIDO_COMPRA = "0792",
    CGR_PRISMA_LISTAR_ATIVIDADES = "0793",
    CGR_PRISMA_CADASTRAR_ANEXO_SOLICITACAO = "0794",
    CGR_PRISMA_LISTAR_ANEXO_SOLICITACAO = "0795",
    CGR_PRISMA_LISTAR_APURACAO = "0811",
    CGR_PRISMA_LANCAMENTOS = "0796",
    CGR_PRISMA_LISTAR_LANCAMENTOS = "0797",
    CGR_PRISMA_CADASTRAR_LANCAMENTOS = "0798",
    CGR_PRISMA_ALTERAR_LANCAMENTOS = "0799",
    CGR_PRISMA_BAIXAR_LANCAMENTOS = "0800",
    CGR_PRISMA_REMOVER_LANCAMENTOS = "0801",

    // CT-e de frete (distribuição DFe) — códigos do Sigest, documentados no CteController do backend
    CGR_PRISMA_CONSULTAR_DFE_CTE = "0805",
    CGR_PRISMA_IMPORTAR_CTE = "0806",

    // NFS-e de serviço tomado (distribuição DFe do ADN) — códigos do Sigest, documentados no NfseController do backend.
    // A 0809 (gerenciar aprovação) ainda não é usada: na etapa 1 qualquer usuário aprova.
    CGR_PRISMA_CONSULTAR_DFE_NFSE = "0808",
    CGR_PRISMA_IMPORTAR_NFSE = "0810",

    CGR_PRISMA_MANUTENCAO_N1_OPERADOR = "0812",
    CGR_PRISMA_MANUTENCAO_N1_GESTAO = "0813",

    CGR_PRISMA_ARTIGOS = "0814",
    CGR_PRISMA_LISTAR_CLASSIFICACAO_ARTIGO = "0815",
    CGR_PRISMA_CADASTRAR_CLASSIFICACAO_ARTIGO = "0816",
    CGR_PRISMA_LISTAR_ARTIGO = "0817",
    CGR_PRISMA_CADASTRAR_ARTIGO = "0818",

    CGR_PRISMA_TRANSFERENCIAS = "0819",
    CGR_PRISMA_LISTAR_TRANSFERENCIAS = "0820",
    CGR_PRISMA_CADASTRAR_TRANSFERENCIAS = "0821",
    CGR_PRISMA_ALTERAR_TRANSFERENCIAS = "0822",
    CGR_PRISMA_REMOVER_TRANSFERENCIAS = "0823",
    CGR_PRISMA_ALTERAR_STATUS_TRANSFERENCIAS = "0824",
    CGR_PRISMA_ALTERAR_TRANSFERENCIAS_EFETIVADAS = "0825",

    CGR_PRISMA_GESTAO_ESTOQUE = "0826",
    CGR_PRISMA_REGISTRAR_MOVIMENTO_ESTOQUE = "0827",
    CGR_PRISMA_LISTAR_FLUXO_CAIXA = "0828",

    CGR_PRISMA_GESTAO_ORDEM_FABRICACAO = "0829",

    CGR_PRISMA_LISTAR_LANCAMENTOS_RECORRENTES = "0831",
    CGR_PRISMA_GERENCIAR_LANCAMENTOS_RECORRENTES = "0832",

}

